import { css } from '@emotion/core';
import { tokens, applyFont, media, buttonNormalize } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var container = /*#__PURE__*/css("text-align:right;", media('>=tablet'), "{position:relative;top:35px;}");
export var dropDownLabel = /*#__PURE__*/css(applyFont(typography.bodyBold), " color:", colors.neutral.heavy.default, ";display:inline-block;vertical-align:middle;");
export var dropDownContainer = {
  name: "v7ibj3",
  styles: "display:inline-block;vertical-align:middle;"
};
export var dropDown = /*#__PURE__*/css("width:215px;margin-left:8px;text-align:left;& > div > button{height:40px;background-color:", colors.neutral.surface.default, ";border-color:", colors.neutral.medium.default, ";color:", colors.neutral.medium.default, ";}");
export var modalDialog = {
  name: "y8aj3r",
  styles: "padding:0;"
};
export var dropDownItem = {
  name: "1u5bkqb",
  styles: "padding:5px 15px;"
};
export var modalDialogContent = {
  name: "hm3law",
  styles: "text-align:left;padding-top:10px;"
};
export var modalDialogTick = /*#__PURE__*/css("color:", colors.interactive.base.default, ";");
export var dropDownToggle = /*#__PURE__*/css(buttonNormalize, ";display:flex;color:", colors.neutral.heavy.default, ";", applyFont(typography.bodyBold), " text-align:right;");
export var dropDownToggleLabel = {
  name: "s1frl9",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden;vertical-align:middle;width:84px;@media (min-width:380px){width:100px;}@media (min-width:400px){width:128px;}@media (min-width:450px){width:auto;}"
};
export var modalDialogHeaderWrapper = /*#__PURE__*/css("border-bottom:1px solid ", colors.neutral.trim.default, ";padding:0 1rem;margin-bottom:1rem;");
export var modalDialogHeader = {
  name: "4eqxqn",
  styles: "display:flex;padding:1rem 0 1rem 0;"
};
export var modalDialogTitleWrapper = {
  name: "f5kn7p",
  styles: "flex-grow:1;padding:0 1rem;"
};
export var modalDialogTitle = /*#__PURE__*/css(applyFont(typography.heading), " color:", colors.neutral.heavy.default, ";");